import { supabase } from "@/lib/supabaseClient";

import {
  CONSENT_SOURCE,
  POLICY_VERSION,
  type ConsentDecision,
} from "./consent-config";

/**
 * Persist a consent decision to the durable audit log (cookie_consents).
 *
 * Best-effort: the cookie is the UX source of truth; a failed DB write
 * must NOT block the visitor. Logs a warning and resolves either way.
 *
 * RLS (SPEC-COOKIE-1) allows anon and authenticated inserts; the policy
 * requires `user_id is null or user_id = auth.uid()`. We read the
 * current session via `supabase.auth.getUser()` so authenticated
 * decisions get tied to the right user automatically; anonymous
 * sessions just send `user_id: null`.
 */
export async function recordConsent(decision: ConsentDecision): Promise<void> {
  try {
    const { data: auth } = await supabase.auth.getUser();
    const userId = auth?.user?.id ?? null;
    const userAgent =
      typeof navigator !== "undefined" && navigator.userAgent
        ? navigator.userAgent.slice(0, 500)
        : null;
    const { error } = await supabase.from("cookie_consents").insert({
      consent_id: decision.consentId,
      user_id: userId,
      necessary: true,
      analytics: decision.analytics,
      marketing: decision.marketing,
      action: decision.action,
      policy_version: POLICY_VERSION,
      source: CONSENT_SOURCE,
      user_agent: userAgent,
    });
    if (error) console.warn("[consent] DB record failed", error);
  } catch (err) {
    console.warn("[consent] recordConsent threw", err);
  }
}
